import { Link } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import iframeStore from "../../../pages/IframeNew/iframe-store";
import styles from "./APIDocsLink.module.scss";

interface IAPIDocsLink {
	label?: string;
	link?: string;
}

const APIDocsLink = ({ label, link }: IAPIDocsLink) => {
	const { t } = useTranslation("translation");

	if (iframeStore.isIframe()) {
		return;
	}

	return (
		<Link
			onClick={(_e: React.MouseEvent<any>) => {
				link && window.open(link, "_blank");
			}}
			className={styles.apiDocsLink}
		>
			{label || t("apiDocs")}
		</Link>
	);
};

export default observer(APIDocsLink);
